import { getAmazonProfile } from './getAmazonProfile';

export const isLoggedInOnAmazon = async () => {
  try {
    await getAmazonProfile();
    return true;
  } catch {
    return false;
  }
};
